import { EnhancedLabeledSelectProps } from '@gorila-shared-ui/components';
import { getLastMonthsList } from '../../utils/dates';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';

type Props = {
  onChange: (dateKey: string) => void;
  monthsCount?: number;
  dateKey: string;
} & Omit<
  EnhancedLabeledSelectProps,
  'value' | 'options' | 'onChange' | 'searchable' | 'fetchDataLoading' | 'maxDropdownHeight'
>;

function LastMonthsSelect({
  dateKey,
  onChange,
  inline = true,
  inset = true,
  label = 'Mes:',
  monthsCount = 3,
  ...props
}: Readonly<Props>) {
  const options = getLastMonthsList(monthsCount);

  return (
    <EnhancedLabeledSelect
      {...props}
      inline={inline}
      inset={inset}
      label={label}
      options={options}
      value={[{ id: dateKey }]}
      onChange={(params) => {
        onChange(params.option?.id as string);
      }}
    />
  );
}

export default LastMonthsSelect;
